import { InputType } from 'config'

const option1 = ['Yes', 'No']
const option2 = ['Email', 'Portal', 'Mail-in']
const option3 = ['Lender', 'Investor']
const option4 = ['DOT', 'FTP', 'Allonge 1', 'Allonge 2', 'AOM 1', 'AOM 2']

export const defaultInputs = (): Record<string, InputType> => {
  return {
    section1: {
      inputType: 'section',
      title: 'Pre-Boarding',
      span: 'full',
    },
    noteProvided: {
      inputType: 'select',
      title: 'Note Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    hudProvided: {
      inputType: 'select',
      title: 'Settlement Statement; Executed or Final HUD Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    taxDocProvided: {
      inputType: 'select',
      title: 'Property Tax Document Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    loanAgreementProvided: {
      inputType: 'select',
      title: 'Loan Agreement Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    floodCertProvided: {
      inputType: 'select',
      title: 'Flood Certification Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    firstPaymentLetterProvided: {
      inputType: 'select',
      title: 'First Payment Letter Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    deedOfTrustProvided: {
      inputType: 'select',
      title: 'Deed of Trust Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    floodInsProvided: {
      inputType: 'select',
      title: 'Flood Insurance Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    mortgageProvided: {
      inputType: 'select',
      title: 'Assignment of Mortgage 1 (AOM1) Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    achProvided: {
      inputType: 'select',
      title: 'ACH Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    hazardInsProvided: {
      inputType: 'select',
      title: 'Hazard Insurance Provided',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    ecommunication: {
      inputType: 'select',
      title: 'ECommunication',
      options: option1,
      hasDefaultOption: true,
      span: 1,
    },
    preBoardingComment: {
      inputType: 'textarea',
      title: 'Pre-Boarding Comments',
      rows: 5,
      span: 'full',
    },
    boardingCompletedBy: {
      inputType: 'text',
      title: 'Boarding Completed By',
      span: 1,
    },
    boardingCompletedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Boarding Completed Date',
      span: 1,
    },
    section2: {
      inputType: 'section',
      title: 'Shipping',
      span: 'full',
    },
    packageShippedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Closing Packaged Shipped to HQ - Date Shipped',
      span: 1,
    },
    packageTracking: {
      inputType: 'text',
      title: 'Closing Packaged Shipped to HQ - Tracking',
      span: 1,
    },
    packageReceivedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Closing Packaged Received at HQ',
      span: 1,
    },
    collateralShippedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Collateral Shipped to Custodian - Date Shipped',
      span: 1,
    },
    collateralTracking: {
      inputType: 'text',
      title: 'Collateral Shipped to Custodian - Tracking',
      span: 1,
    },
    custom1: {
      inputType: 'custom',
      title: '',
      span: 1,
    },
    custodianReceivedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Custodian Received Collateral Date',
      span: 1,
    },
    custodianCleardDate: {
      inputType: 'text',
      type: 'date',
      title: 'Custodian Cleared Collateral Date',
      span: 1,
    },
    shippingComment: {
      inputType: 'textarea',
      title: 'Shipping Comments',
      rows: 5,
      span: 'full',
    },
    shippingCompletedBy: {
      inputType: 'text',
      title: 'Shipping Completed By',
      span: 1,
    },
    shippingCompletedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Shipping Completed Date',
      span: 1,
    },
    section3: {
      inputType: 'section',
      title: 'Trailing Documents',
      span: 'full',
    },
    group1: {
      inputType: 'group',
      title: 'Deed of Trust / Mortgage (DOT)',
      span: 'full',
    },
    dotRequestedDate: {
      inputType: 'text',
      type: 'date',
      title: 'DOT Requested Date',
      span: 1,
    },
    group2: {
      inputType: 'group',
      title: 'Final Title Policy (FTP)',
      span: 'full',
    },
    ftpRequestedDate: {
      inputType: 'text',
      type: 'date',
      title: 'FTP Requested Date',
    },
    ftpReceivedDate: {
      inputType: 'text',
      type: 'date',
      title: 'FTP Received Date',
    },
    ftpDateSentToCustodian: {
      inputType: 'text',
      type: 'date',
      title: 'FTP Date Sent to Custodian',
    },
    ftpDeliverySource: {
      inputType: 'text',
      title: 'FTP Source of Delivery',
    },
    ftpCopySentToCustodian: {
      inputType: 'select',
      options: option3,
      title: 'FTP Copy Sent to Custodian',
      hasDefaultOption: true,
    },
    ftpCorrectiveRequested: {
      inputType: 'select',
      options: option1,
      title: 'FTP Corrective Requested',
      hasDefaultOption: true,
    },
    trailingDocumentComments: {
      inputType: 'textarea',
      title: 'Trailing Documents Comments',
      rows: 5,
      span: 'full',
    },
    trailingDocsCompletedBy: {
      inputType: 'text',
      title: 'Trailing Docs Completed By',
      span: 1,
    },
    trailingDocsCompletedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Trailing Docs Completed Date',
      span: 1,
    },
    section4: {
      inputType: 'section',
      title: 'Mortgage Assignments',
      span: 'full',
    },
    group3: {
      inputType: 'group',
      title: 'Assignment of Mortgage (AOM)',
      span: 'full',
    },
    executedAom2: {
      inputType: 'text',
      type: 'date',
      title: 'Executed AOM 2',
    },
    aomComments: {
      inputType: 'textarea',
      title: 'AOM Comments',
      span: 2,
    },
    group4: {
      inputType: 'group',
      title: 'Allonge',
      span: 'full',
    },
    executedAllonge1: {
      inputType: 'text',
      type: 'date',
      title: 'Executed Allonge 1',
    },
    executedAllonge2: {
      inputType: 'text',
      type: 'date',
      title: 'Executed Allonge 2',
    },
    allongeComments: {
      inputType: 'textarea',
      title: 'AOM Comments',
      span: 'full',
    },
    section5: {
      inputType: 'section',
      title: 'Loan Trade',
      span: 'full',
    },
    group5: {
      inputType: 'group',
      title: 'Pre-Sale Exceptions',
      span: 'full',
    },
    group6: {
      inputType: 'group',
      title: 'Post-Sale Exceptions',
      span: 'full',
    },
  }
}

export const dotInputs = (): Record<string, InputType> => {
  return {
    dateReceived: {
      inputType: 'text',
      type: 'date',
      title: 'DOT Recorded Received Date',
      span: 1,
    },
    information: {
      inputType: 'text',
      title: 'DOT Recording Information',
      span: 1,
    },
    dotCustom1: {
      inputType: 'custom',
      title: '',
      span: 1,
    },
    copyDateReceived: {
      inputType: 'text',
      type: 'date',
      title: 'DOT Recorded Copy Date Received',
    },
    copySentToCustodian: {
      inputType: 'text',
      title: 'DOT Recorded Copy Sent to Custodian',
      span: 1,
    },
    copySentToCustodianDate: {
      inputType: 'text',
      type: 'date',
      title: 'DOT Recorded Copy Sent to Custodian Date',
    },
    dotSource: {
      inputType: 'select',
      options: option2,
      title: 'DOT Source of Delivery to Custodian',
      hasDefaultOption: true,
    },
    trackingNumber: {
      inputType: 'text',
      title: 'DOT Tracking Number',
      span: 1,
    },
    correctRequested: {
      inputType: 'select',
      options: option1,
      title: 'DOT Correct Requested',
      hasDefaultOption: true,
      span: 1,
    },
  }
}

export const aomInputs = (): Record<string, InputType> => {
  return {
    assignmentType: {
      inputType: 'select',
      options: ['AOM 1', 'AOM 3', 'Corrective', 'Repurchase'],
      hasDefaultOption: true,
      title: 'Assignment Type',
    },
    aomExecuted: {
      inputType: 'text',
      type: 'date',
      title: 'AOM Executed',
    },
    executedAomSentForRecording: {
      inputType: 'text',
      type: 'date',
      title: 'Executed AOM Sent for Recording',
    },
    aomDateRecorded: {
      inputType: 'text',
      type: 'date',
      title: 'AOM Date Recorded',
    },
    aomDateSentToCustodian: {
      inputType: 'text',
      type: 'date',
      title: 'AOM Date Sent to Custodian',
    },
    aomSource: {
      inputType: 'select',
      options: option2,
      title: 'AOM Source of Delivery',
      hasDefaultOption: true,
    },
    aomSourceTracking: {
      inputType: 'text',
      title: 'AOM Source of Delivery - Tracking',
    },
    aomRecordedCopySentToCustodian: {
      inputType: 'select',
      options: option3,
      title: 'AOM Recorded Copy Sent to Custodian  ',
      hasDefaultOption: true,
    },
    aomCompletedBy: {
      inputType: 'text',
      title: 'AOM Completed By',
      span: 1,
    },
    aomCompletedDate: {
      inputType: 'text',
      type: 'date',
      title: 'AOM Completed Date',
      span: 1,
    },
  }
}

export const preSaleInputs = (type: string): Record<string, InputType> => {
  return {
    exceptionType: {
      inputType: 'select',
      options: option4,
      hasDefaultOption: true,
      title: `${type} Exception Type`,
    },
    dateExceptionIssued: {
      inputType: 'text',
      type: 'date',
      title: 'Date Exception Issued',
    },
    dateExceptionSentToInvestor: {
      inputType: 'text',
      type: 'date',
      title: 'Date Exception Sent to Investor',
    },
    exceptionSource: {
      inputType: 'select',
      options: option2,
      hasDefaultOption: true,
      title: `Exception Source of Delivery to Custodian`,
    },
    exceptionTracking: {
      inputType: 'text',
      title: 'Exception Tracking (if mailed)',
    },
    exceptionCompletedBy: {
      inputType: 'text',
      title: `${type} Exception Completed By`,
    },
    exceptionComment: {
      inputType: 'textarea',
      title: `${type} Exception Comment`,
      span: 'full',
    },
  }
}

export const inputGroups: Record<string, any> = {
  dotRecords: dotInputs(),
  aomRecords: aomInputs(),
  preSaleRecords: preSaleInputs('Pre-Sale'),
  postSaleRecords: preSaleInputs('Post-Sale'),
}

export const inputGroupBeforeKeys: Record<string, string> = {
  dotRequestedDate: 'dotRecords',
  group3: 'aomRecords',
  group5: 'preSaleRecords',
  group6: 'postSaleRecords',
}
